import React, { useState } from 'react';
import classNames from 'classnames/bind';
import { Container, Form, Row, Col, ButtonGroup, Button, ToggleButton, Badge, Pagination, Spinner } from 'react-bootstrap';
import { Column } from 'react-table';
import { Table } from './table';
import { CSVLink } from "react-csv";

import SelectSearch, { fuzzySearch } from 'react-select-search';
import "./select-search.css";
import { useAsync, useAsyncRetry } from 'react-use';
import api from '../../api';
import { useWarrantrInquire } from "../../hook/useWarrantrInquire"

import { target } from '../../api/newApi/getTargetsQuery'
import { Publisher } from '../../api/newApi/getPublisherQuery'
import { WarrantQueryType } from '../../api/newApi/getWarrantQuery'
import { UserGuideQuery } from '../../api/newApi/userGuideQuery'
import { UserGuideClose } from '../../api/newApi/userGuideClose'
import { cpOption, priceOption, dayOption, percentOption, qtyOption, dfOption, lvOption } from './option'
import OrderModel from '../../components/OrderModel';
import BeginnerModel from '../../components/BeginnerGuideModel';
import ShareModel from '../../components/ShareGuideModel';
import dayjs from "dayjs";
import ReactTooltip from 'react-tooltip';


import { toast } from "react-toastify";
import style from './index.module.css';

const cx = classNames.bind(style);

export interface Order {
  cuid: string,
  campaignName: string | null;
  sessionId: string | null;
  mtype: string;
  invitationCode: string | null;
  handleOninvitationCode: (code: string) => void;
  campaign_active: boolean;
  continueBell: () => void;
}
interface SelectTarget {
  name: string;
  value: string;
  key?: string;
}


function useUserGuideQuery(cuid: string) {
  const { value, loading, retry } = useAsyncRetry(() => api.userGuideQuery({ cu_id: cuid }), []);

  const GuideDisplay = React.useMemo(() => {
    return value?.display || false
  }, [loading]);


  return {
    retry,
    GuideDisplay,
  };
}



function useWarrantCsv(cuid: string,
  symid: string,
  cp: string,
  p1: number,
  p2: number,
  d1: number,
  d2: number,
  r1: number,
  r2: number,
  pub: string,
  ep1: number,
  ep2: number,
  qty1: number,
  qty2: number,
  df1: number,
  df2: number,
  lv1: number,
  lv2: number,
  page: number,
  tableAsc: string,
  asc: boolean,
  retryToggle: boolean,
) {
  const { loading, value, retry } = useAsyncRetry(() => api.getWarrantQuery({
    cu_id: cuid,
    sym: symid,
    cp: cp,
    p1: p1,
    p2: p2,
    d1: d1,
    d2: d2,
    r1: r1,
    r2: r2,
    pub: pub,
    ep1: ep1,
    ep2: ep2,
    qty1: qty1,
    qty2: qty2,
    df1: df1,
    df2: df2,
    lv1: lv1,
    lv2: lv2,
    // 一次撈上線3000筆
    rows: 3000,
    // page = 1,都是取第一頁的資料3000筆
    page: 1, 
    order: tableAsc,
    asc: asc,
  }), [cuid, page, tableAsc, asc, retryToggle]);

  function Formatter(data: any): any {
    return {
      "權證代號": data.stock_id,
      "權證名稱": data.stock_name,
      "權證價格": data.stock_money,
      "委買價": data.stock_buy,
      "委賣價": data.stock_sale,
      "漲跌%": data.stock_percent,
      "標的價格": data.target_money,
      "標的漲跌%": data.target_percent,
      "履約價": data.run_money,
      "行使比例": data.run_num,
      "價內外程度%": data.run_percent,
      "剩餘天數": data.surplus_day,
      "實質槓桿": data.lever,
      // "成交量": data.volume,
      "買價波動率%": data.percent_buy,
      "價差比%": data.diff_ratio,
      // "標的名稱": data.target_name_1,
      // "標的代碼": data.target_name_2,
      "發行人": data.publisher,
    };
  }


  const warrantsCsv = React.useMemo(() => {
    return value?.warrant ? value.warrant.map(Formatter) : []
  }, [loading]);



  return {
    retry,
    loading,
    warrantsCsv,
  };
}


const Order: React.FC<Order> = (props) => {
  const { cuid, campaignName, sessionId, mtype, invitationCode, handleOninvitationCode, campaign_active, continueBell } = props

  const { GuideDisplay, retry } = useUserGuideQuery(cuid)
  const Digits2NumberFormatter = (value: string) =>
    (+value).toLocaleString(undefined, {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
  const Digits3NumberFormatter = (value: string) =>
    (+value).toLocaleString(undefined, {
      minimumFractionDigits: 3,
      maximumFractionDigits: 3,
    });
  const { targets } = useTargetsInfo()
  const { publisher } = usePublisherInfo()

  const [show, setShow] = useState(false);
  const [showinviteModel, setShowinviteModel] = useState(false);
  const [istop6K, setIstop6K] = useState<boolean | null>(null);
  //20230813開始活動 前1000名獲得line points
  const [isPrize, setIsPrize] = useState<boolean | null>(null);

  const [symCnName, setSymCnName] = useState<string>("");
  const [orderSym, setOrderSym] = useState<string>("");
  const [orderBS, setOrderBS] = useState<"B" | "S" | null>(null);
  const [orderP1, setOrderP1] = useState<number | null>(null);
  const [orderQty, setOrderQty] = useState<number>(1);
  const [orderTif, setOrderTif] = useState<"R" | "F" | "I" | null>(null);
  const [orderOrt, setOrderOrt] = useState<"1" | "2" | null>(null);
  const [t1, setT1] = useState<string>(dayjs().format("YYYY/MM/DD HH:mm:ss.000"))
  const [t2, setT2] = useState<string>("")
  const handleClose = () => {
    setShow(false);
    setSymCnName("");
    setOrderSym("");
    setOrderBS(null);
    setOrderP1(null);
    setOrderQty(1);
    setOrderTif(null);
    setOrderOrt(null);
    setTimeout(() => {
      (window.parent as any).showBanner(1);
      (window.parent as any).scrollTo({
        top: 0,
        behavior: 'smooth',
        scrollBehavior: 'smooth'
      });
    }, 100)

  };



  const handleOrder = (row: any) => {
    console.log('campaign1', campaign_active)
    if (!campaign_active) {
      const t1 = dayjs().subtract(3, 'second').format("YYYY/MM/DD HH:mm:ss.000");
      const t2 = dayjs().format("YYYY/MM/DD HH:mm:ss.000");
      setT1(t1);
      setT2(t2);
      if (!campaign_active) {

        //debugger
        api.bellCheck({ cu_id: cuid, t1: t1, t2: t2 }).then((e) => {
          if (e?.err === "1200") {
            //debugger
            toast.warn('非系統交易時間！', {
              position: "top-right",
              autoClose: false,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
            });
            (window.parent as any).scrollTo({
              top: 11,
              behavior: 'smooth',
            });
            return;
          } else {
            continueBell();
            setShow(true);
            setSymCnName(row.stock_name);
            setOrderSym(row.stock_id);
            setOrderTif("R");
            setOrderBS("B");
            setOrderP1(row.stock_money);
            setOrderOrt("2");
            setT_up_stop(row.t_up_stop);
            setT_down_stop(row.t_down_stop);
            setTarget_money(row.target_money);
            (window.parent as any).showBanner(0);
            (window.parent as any).scrollTo({
              top: 11,
              behavior: 'smooth',
            });
          }
        })
      }
    } else {
      setShow(true);
      setSymCnName(row.stock_name);
      setOrderSym(row.stock_id);
      setOrderTif("R");
      setOrderBS("B");
      setOrderP1(row.stock_money);
      setOrderOrt("2");
      setT_up_stop(row.t_up_stop);
      setT_down_stop(row.t_down_stop);
      setTarget_money(row.target_money);
      (window.parent as any).showBanner(0);
      (window.parent as any).scrollTo({
        top: 11,
        behavior: 'smooth',
      });
    }
  };

  const handlePrice = (price: number) => {
    setOrderP1(price)
    setOrderOrt("2")
  };

  const handlePriceType = (type: "1" | "2" | null) => {
    setOrderOrt(type)
    if (type === "1") {
      setOrderP1(0)
    }
  };
  //order下單
  const handleOrderPlace = () => {
    if (!orderBS || !orderTif || !orderOrt || orderP1 == null) {
      toast.warn('請填妥下單條件', {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      return
    }
    if (orderOrt === "2" && (!orderP1 || Number(orderP1) <= 0 || orderP1 <= 0)) {
      toast.warn('限價單請輸入價格', {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      return
    }

    api.OrderPlace({
      cu_id: cuid,
      src: "WEB",
      sym: orderSym,
      bS1: orderBS,
      p1: orderP1,
      qty: orderQty,
      tif: orderTif,
      ort: orderOrt,
      icc: invitationCode === null ? "1" : "0",
    }).then((e) => {
      handleClose();
      if (!e.inv_code) { return }
      if (e.inv_code) {
        handleOninvitationCode(e.inv_code)
      }
      if (e.top6K) {
        setIstop6K(e.top6K)
      }
      // 回傳獎勵是true 代表有早鳥優惠 false 代表沒有
      if (e.prize) {
        setIsPrize(e.prize)
      }
      setShowinviteModel(true)
    })
  };


  const [warrants, setWarrants] = useState<any>(null);
  const [retryToggle, setRetryToggle] = useState<boolean>(false);
  const [sym, setSym] = useState<any>(sessionStorage.getItem('cuid') ? (`${sessionStorage.getItem('sym')}(${sessionStorage.getItem('symId')})`) : null);
  const [symid, setSymId] = useState<any>(null);
  const [cp, setCp] = useState<any>("");
  const [p1, setP1] = useState<any>(9999);
  const [p2, setP2] = useState<any>(9999);
  const [d1, setD1] = useState<any>(9999);
  const [d2, setD2] = useState<any>(9999);
  const [r1, setR1] = useState<any>(9999);
  const [r2, setR2] = useState<any>(9999);
  const [pub, setPub] = useState<any>("");
  const [ep1, setEp1] = useState<any>("");
  const [ep2, setEp2] = useState<any>("");
  const [qty1, setQty1] = useState<any>(999999);
  const [qty2, setQty2] = useState<any>(999999);
  const [df1, setDf1] = useState<any>(999999);
  const [df2, setDf2] = useState<any>(999999);
  const [lv1, setLv1] = useState<any>(999999);
  const [lv2, setLv2] = useState<any>(999999);
  const [tableAsc, setTableAsc] = useState<any>("diff_ratio");
  const [page, setPage] = useState<number>(1);
  const [asc, setAsc] = useState<boolean>(true);
  const [reload, setReload] = useState<boolean>(true);
  const RELOAD_TIME = 60000;


  //sessionStorage.getItem('cuid') ? setInfoFromRankReload(true) : setInfoFromRankReload(false)

  const getDataFromRank = async () => {
    if (sessionStorage.getItem('cuid')) {

      setSymId(sessionStorage.getItem('symId'))
      setCp(sessionStorage.getItem('type'))
      setP1(15)
      setP2(-25)
      setD1(60)
      setPub("")
      setPage(1)
      setTableAsc("diff_ratio")
      setAsc(true)
      setRetryToggle(!retryToggle)
      // const reloadWarrantPack = await api.getWarrantQuery({
      //   cu_id: cuid,
      //   sym: symid,
      //   cp: cp,
      //   p1: p1,
      //   p2: p2,
      //   d1: d1,
      //   d2: d2,
      //   r1: r1,
      //   r2: r2,
      //   pub: pub,
      //   ep1: ep1,
      //   ep2: ep2,
      //   qty1: qty1,
      //   qty2: qty2,
      //   df1: df1,
      //   df2: df2,
      //   lv1: lv1,
      //   lv2: lv2,
      //   page: page,
      //   order: tableAsc,
      //   asc: asc,
      // })
      //   console.log("???????????",reloadWarrantPack)
      //   if(reloadWarrantPack?.warrant&&reloadWarrantPack?.warrant!==null){
      //     setWarrants(reloadWarrantPack?.warrant)
      //     }
    }
    setTimeout(() => {
      sessionStorage.removeItem('cuid')
      sessionStorage.removeItem('sym')
      sessionStorage.removeItem('symId')
      sessionStorage.removeItem('type')
      sessionStorage.removeItem('code')
      sessionStorage.removeItem('userName')
      sessionStorage.removeItem('inv_code')
    }, 1000)
  }

  React.useEffect(() => {
    getDataFromRank()
  }, [])

  /**設定一分鐘重新刷新抓一次DB資料 去更新run_percent  diff_ratio ，相對的BNS Socket進來這兩項就不用更新*/
  async function reloadWarrantList(cuid: string,
    symid: string,
    cp: string,
    p1: number,
    p2: number,
    d1: number,
    d2: number,
    r1: number,
    r2: number,
    pub: string,
    ep1: number,
    ep2: number,
    qty1: number,
    qty2: number,
    df1: number,
    df2: number,
    lv1: number,
    lv2: number,
    page: number,
    tableAsc: string,
    asc: boolean,
  ) {
    const reloadWarrantPack = await api.getWarrantQuery({
      cu_id: cuid,
      sym: symid,
      cp: cp,
      p1: p1,
      p2: p2,
      d1: d1,
      d2: d2,
      r1: r1,
      r2: r2,
      pub: pub,
      ep1: ep1,
      ep2: ep2,
      qty1: qty1,
      qty2: qty2,
      df1: df1,
      df2: df2,
      lv1: lv1,
      lv2: lv2,
      page: page,
      order: tableAsc,
      asc: asc,
    })
    if (reloadWarrantPack?.warrant && reloadWarrantPack?.warrant !== null) {
      setWarrants(reloadWarrantPack?.warrant)
    }

  }


  // 母股漲停
  const [t_up_stop, setT_up_stop] = useState<number | null>(null)
  // 母股跌停
  const [t_down_stop, setT_down_stop] = useState<number | null>(null)
  //母股現價
  const [target_money, setTarget_money] = useState<string>('')

  const { loading: warrantsCsvWarrantLoading, warrantsCsv } = useWarrantCsv(
    cuid,
    symid,
    cp,
    p1,
    p2,
    d1,
    d2,
    r1,
    r2,
    pub,
    ep1,
    ep2,
    qty1,
    qty2,
    df1,
    df2,
    lv1,
    lv2,
    page,
    tableAsc,
    asc,
    retryToggle
  )

  const getWarrant = useWarrantrInquire({
    cuid,
    symid,
    cp,
    p1,
    p2,
    d1,
    d2,
    r1,
    r2,
    pub,
    ep1,
    ep2,
    qty1,
    qty2,
    df1,
    df2,
    lv1,
    lv2,
    page,
    tableAsc,
    asc,
    retryToggle,
    sessionId,
    mtype,
  });

  const warrantrData = getWarrant.value ? getWarrant.value.warrant : []
  const warrantrDataCount = getWarrant.value?.recs || 0
  const warrantrPages = getWarrant.value?.pages || 0

  const queryTime = getWarrant.value ? getWarrant.value.QueryTime : ""

  /**設定一分鐘重新刷新抓一次DB資料 去更新run_percent  diff_ratio ，並利用settimeout讓每次reload在四分鐘後改動重新觸發 利用小鈴鐺確認是否為盤中 若不是盤中就不call
   */
  React.useEffect(() => {
    const t1 = dayjs().subtract(3, 'second').format("YYYY/MM/DD HH:mm:ss.000");
    const t2 = dayjs().format("YYYY/MM/DD HH:mm:ss.000");
    api.bellCheck({ cu_id: cuid, t1: t1, t2: t2 }).then((e) => {
      if (e?.err === "1200") {
        return;
      } else {
        reloadWarrantList(
          cuid,
          symid,
          cp,
          p1,
          p2,
          d1,
          d2,
          r1,
          r2,
          pub,
          ep1,
          ep2,
          qty1,
          qty2,
          df1,
          df2,
          lv1,
          lv2,
          page,
          tableAsc,
          asc,
        )

        setTimeout(() => { setReload(!reload) }, RELOAD_TIME)
        // console.log('reloadreload',warrants)
      }
    })
  }, [reload])


  React.useEffect(() => {
    const newData = getWarrant.value ? getWarrant.value.warrant : []
    const data: any = []
    setWarrants(() => {
      return data.concat(newData)
    });
    (window.parent as any).resizeIframe();
  }, [getWarrant])

  //解決搜尋的warrant數量不足一頁的問題
  React.useEffect(() => {
    (window.parent as any).resizeIframe();
  }, [warrants])

  const search = () => {
    if (symid === null) {
      toast.warn(`請選擇代碼名稱！`, {
        position: "top-right",
        autoClose: 1300,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
      return
    }
    if (cp === null) {
      toast.warn(`請選擇認購/認售！`, {
        position: "top-right",
        autoClose: 1300,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
      return
    }
    setPage(1)
    setRetryToggle(!retryToggle)
    // reSet()
    // console.log(
    //   {
    //     sym: sym,
    //     cp: cp,
    //     p1: p1,
    //     p2: p2,
    //     d1: d1,
    //     d2: d2,
    //     r1: r1,
    //     r2: r2,
    //     pub: pub,
    //     ep1: ep1,
    //     ep2: ep2,
    //     qty1: qty1,
    //     qty2: qty2,
    //     df1: df1,
    //     df2: df2,
    //     lv1: lv1,
    //     lv2: lv2,
    //   }
    // )

  }

  const reSet = () => {
    setSym(null)
    setSymId(null)
    setCp("")
    setP1(9999)
    setP2(9999)
    setD1(9999)
    setD2(9999)
    setR1(9999)
    setR2(9999)
    setPub("")
    setEp1("")
    setEp2("")
    setQty1(999999)
    setQty2(999999)
    setDf1(999999)
    setDf2(999999)
    setLv1(999999)
    setLv2(999999)
    setTableAsc("diff_ratio")
  }


  const handleChangeSort = (hand: string,) => {
    setTableAsc(hand)
    if (tableAsc === hand) { setAsc(!asc) } else { setAsc(true) }
  }
  const handleOnchange = (e: any,) => {
    const splitWord = e.substring(
      e.indexOf("(") + 1,
      e.lastIndexOf(")")
    );
    console.log('?????????', splitWord)
    console.log('?????????', e)
    setSym(e)
    setSymId(splitWord)
  }


  const handleShareModelClose = () => {
    setShowinviteModel(false);
    (window.parent as any).showBanner(1);
  }
  const columns = React.useMemo<Column<WarrantQueryType>[]>(
    () => [

      {
        Header: <><div className={cx("tablehaderWrap", "action-w")}>選項</div></>,
        accessor: "action",
        sticky: "left",
        disableSortBy: true,
        tipText: '',
        Cell: cellInfo => <div className={cx("btnwrap", "action-w")} >
          <button className={cx("btn", "order")} onClick={() => handleOrder(cellInfo.cell.row.original)}>下單</button>
          <button className={cx("btn", "self", cellInfo.cell.row.original.favor && "selfactive")} onClick={
            () => {
              if (cellInfo.cell.row.original.favor) {
                api.favoriteRemove({ cu_id: cuid, stock_id: cellInfo.cell.row.original.stock_id as string }).then((e) => {
                  setRetryToggle(!retryToggle);
                })
              } else {
                api.favoriteAdd({ cu_id: cuid, stock_id: cellInfo.cell.row.original.stock_id as string }).then((e) => {
                  setRetryToggle(!retryToggle);
                })
              }
            }
          }>自選</button>
        </div >
      },
      {
        Header: <><div className={cx()} data-tip="由權證連結標的、發行商、到期年月、權證類型及序號所組成，更詳細說明請參閱 權證懶人包>快速入門>>權證小百科。">權證<br />名稱</div><ReactTooltip place="top" type="light" effect="solid" /></>,
        accessor: "stock_name",
        sticky: "left",
        tipText: '由權證連結標的、發行商、到期年月、權證類型及序號所組成，更詳細說明請參閱 權證懶人包>快速入門>>權證小百科。',
        Cell: cellInfo => <>
          {<div onClick={() => handleOrder(cellInfo.cell.row.original)}>{cellInfo.cell.row.original.stock_name}</div>}
        </>
      },
      {
        Header: <><div className={cx("tablehaderWrap")} data-tip="由六位數組成。更詳細說明請參閱 權證懶人包>快速入門>>權證小百科。">權證<br />代號</div><ReactTooltip place="top" type="light" effect="solid" /></>,
        accessor: "stock_id",
        disableSortBy: true,
        tipText: '由六位數組成。更詳細說明請參閱 權證懶人包>快速入門>>權證小百科。',
        Cell: cellInfo => <>
          {<div className={cx("tablewrap")} onClick={() => handleOrder(cellInfo.cell.row.original)} >{cellInfo.cell.row.original.stock_id}</div>}
        </>
      },
      {
        Header: <><div className={cx("tablehaderWrap")} data-tip="權證最佳一檔買價">委買<br />價(元)</div><ReactTooltip place="top" type="light" effect="solid" /></>,
        accessor: "stock_buy",
        tipText: '權證最佳一檔買價',
        Cell: cellInfo => <>
          {<div className={cx("tablewrap",
            Number(cellInfo.cell.row.original.stock_buy) && Number(cellInfo.cell.row.original.ref_price) ?
              Number(cellInfo.cell.row.original.stock_buy) > Number(cellInfo.cell.row.original.ref_price) ? "red" :
                Number(cellInfo.cell.row.original.stock_buy) < Number(cellInfo.cell.row.original.ref_price) ? "green" : "" : ""
          )}>{Digits2NumberFormatter(cellInfo.cell.row.original.stock_buy)}</div>}
        </>
      },
      {
        Header: <><div className={cx("tablehaderWrap")} data-tip="權證最佳一檔賣價">委賣<br />價(元)</div><ReactTooltip place="top" type="light" effect="solid" /></>,
        accessor: "stock_sale",
        tipText: '權證最佳一檔賣價',
        Cell: cellInfo => <>
          {<div className={cx("tablewrap",
            Number(cellInfo.cell.row.original.stock_sale) && Number(cellInfo.cell.row.original.ref_price) ?
              Number(cellInfo.cell.row.original.stock_sale) > Number(cellInfo.cell.row.original.ref_price) ? "red" :
                Number(cellInfo.cell.row.original.stock_sale) < Number(cellInfo.cell.row.original.ref_price) ? "green" : "" : ""
          )}>{Digits2NumberFormatter(cellInfo.cell.row.original.stock_sale)}</div>}
        </>
      },
      {
        Header: <><div className={cx("tablehaderWrap")} data-tip="權證最近成交之價格">權證<br />價(元)</div><ReactTooltip place="top" type="light" effect="solid" /></>,
        accessor: "stock_money",
        tipText: '權證最近成交之價格',
        Cell: cellInfo => <>
          {<div className={cx("tablewrap",
            Number(cellInfo.cell.row.original.stock_money) && Number(cellInfo.cell.row.original.ref_price) ?
              Number(cellInfo.cell.row.original.stock_money) > Number(cellInfo.cell.row.original.ref_price) ? "red" :
                Number(cellInfo.cell.row.original.stock_money) < Number(cellInfo.cell.row.original.ref_price) ? "green" : "" : ""
          )}>{Number(cellInfo.cell.row.original.stock_money) > 0 ? Digits2NumberFormatter(cellInfo.cell.row.original.stock_money) : "--"}</div>}
        </>
      },
      {
        Header: <><div className={cx("tablehaderWrap")} data-tip="(權證價-權證開盤參考價)/權證開盤參考價">漲跌<br />(%)</div><ReactTooltip place="top" type="light" effect="solid" /></>,
        accessor: "stock_percent",
        tipText: '(權證價-權證開盤參考價)/權證開盤參考價',
        Cell: cellInfo => <>
          {<div className={cx("tablewrap", Number(cellInfo.cell.row.original.stock_percent) > 0 ? "red" : Number(cellInfo.cell.row.original.stock_percent) < 0 ? "green" : "")}>{Digits2NumberFormatter(cellInfo.cell.row.original.stock_percent)}</div>}

        </>
      },
      {
        Header: <><div className={cx("tablehaderWrap")} data-tip="該權證連結標的最近成交之價格">標的<br />價格</div><ReactTooltip place="top" type="light" effect="solid" /></>,
        accessor: "target_money",
        tipText: '該權證連結標的最近成交之價格',
        Cell: cellInfo => <>
          {<div className={cx("tablewrap", Number(cellInfo.cell.row.original.target_percent) > 0 ? "red" :
            Number(cellInfo.cell.row.original.target_percent) < 0 ? "green" : "")}>{Digits2NumberFormatter(cellInfo.cell.row.original.target_money)}</div>
          }
        </>
      },
      {
        Header: <><div className={cx("tablehaderWrap")} data-tip="(標的價格-標的開盤參考價)/標的開盤參考價">標的<br />漲跌%</div><ReactTooltip place="top" type="light" effect="solid" /></>,
        accessor: "target_percent",
        tipText: '(標的價格-標的開盤參考價)/標的開盤參考價',
        Cell: cellInfo => <>
          {<div className={cx("tablewrap", Number(cellInfo.cell.row.original.target_percent) > 0 ? "red" : Number(cellInfo.cell.row.original.target_percent) < 0 ? "green" : "")}>{Digits2NumberFormatter(cellInfo.cell.row.original.target_percent)}</div>}
        </>
      },
      {
        Header: <><div className={cx("tablehaderWrap")} data-tip="為發行商所制定之權證條件之一，與現股價格組成一價內外關係，更詳細說明請參閱 權證懶人包>快速入門>>權證小百科。">履約<br />價格</div><ReactTooltip place="top" type="light" effect="solid" /></>,
        accessor: "run_money",
        tipText: '為發行商所制定之權證條件之一，與現股價格組成一價內外關係，更詳細說明請參閱 權證懶人包>快速入門>>權證小百科。',
        Cell: cellInfo => <>
          {<div className={cx("tablewrap")}>{Digits2NumberFormatter(cellInfo.cell.row.original.run_money.toString())}</div>}
        </>
      },
      {
        Header: <><div className={cx("tablehaderWrap")} data-tip="為發行商所制定之權證條件之一，為一張權證所表彰之標的張數。">行使<br />比例</div><ReactTooltip place="top" type="light" effect="solid" /></>,
        accessor: "run_num",
        tipText: '為發行商所制定之權證條件之一，為一張權證所表彰之標的張數。',
        Cell: cellInfo => <>
          {<div className={cx("tablewrap")}>{Digits3NumberFormatter(cellInfo.cell.row.original.run_num.toString())}</div>}
        </>
      },
      {
        Header: <><div className={cx("tablehaderWrap")} data-tip="標的價格距權證履約價之比例">價內外<br />程度%</div><ReactTooltip place="top" type="light" effect="solid" /></>,
        accessor: "run_percent",
        tipText: '標的價格距權證履約價之比例',
        Cell: cellInfo => <>
          {<div className={cx("tablewrap")}>{cellInfo.cell.row.original.run_percent > 0 ? "價內" : "價外"}<br />{Math.abs(cellInfo.cell.row.original.run_percent)}</div>}
        </>
      },
      {
        Header: <><div className={cx("tablehaderWrap")} data-tip="距離到期日前之日曆天數">剩餘<br />天數</div><ReactTooltip place="top" type="light" effect="solid" /></>,
        accessor: "surplus_day",
        tipText: '距離到期日前之日曆天數',
        Cell: cellInfo => <>
          {<div className={cx("tablewrap")}>{cellInfo.cell.row.original.surplus_day}</div>}
        </>
      },
      {
        Header: <><div className={cx("tablehaderWrap")} data-tip="現股漲跌一倍，權證將漲跌之倍數">實質<br />槓桿</div><ReactTooltip place="top" type="light" effect="solid" /></>,
        accessor: "lever",
        tipText: '現股漲跌一倍，權證將漲跌之倍數',
        Cell: cellInfo => <>
          {<div className={cx("tablewrap")}>{Digits2NumberFormatter(cellInfo.cell.row.original.lever.toString())}</div>}
        </>
      },
      {
        Header: <><div className={cx("tablehaderWrap")} data-tip="由權證買價反推之隱含波動率">買價<br />波動率%</div><ReactTooltip place="top" type="light" effect="solid" /></>,
        accessor: "percent_buy",
        tipText: '由權證買價反推之隱含波動率',
        Cell: cellInfo => <>
          {<div className={cx("tablewrap")}>{Digits2NumberFormatter(cellInfo.cell.row.original.percent_buy)}</div>}
        </>
      },
      {
        Header: <><div className={cx("tablehaderWrap")} data-tip="100%*(權證賣價-權證買價)/權證買價">價差比<br />(%)</div><ReactTooltip place="top" type="light" effect="solid" /></>,
        accessor: "diff_ratio",
        tipText: '100%*(權證賣價-權證買價)/權證買價',
        Cell: cellInfo => <>
          {<div className={cx("tablewrap")}>{Digits2NumberFormatter(cellInfo.cell.row.original.diff_ratio.toString())}</div>}
        </>
      },
    ],
    [warrants]
  );

  return (
    <Container className={cx("container-left")} fluid="xl">
      <div className={cx("text-color", " container-left")}>
        <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" fill="currentColor" className="text-color bi bi-play" viewBox="0 0 16 16">
          <path d="M10.804 8 5 4.633v6.734L10.804 8zm.792-.696a.802.802 0 0 1 0 1.392l-6.363 3.692C4.713 12.69 4 12.345 4 11.692V4.308c0-.653.713-.998 1.233-.696l6.363 3.692z" />
        </svg>
        目前盤別：{campaignName ? campaignName : "尚未選擇活動"}
      </div>
      <div className={cx("bg-white", "rounded-lg", "shadow-sm", "mb-5")} >
        <Row className={cx("py-3", "align-items-center", "border-bottom")} >
          <div className={cx("col", "text-blue-light", "mb-sm-0", "fontSize-22")}
          >
            <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="currentColor" className="text-color" viewBox="0 0 16 16">
              <path d="M10.804 8L5 4.633v6.734L10.804 8zm.792-.696a.802.802 0 0 1 0 1.392l-6.363 3.692C4.713 12.69 4 12.345 4 11.692V4.308c0-.653.713-.998 1.233-.696l6.363 3.692z" />
            </svg>標的股票
          </div>
          <Col className={cx("px-2 ", "border-left")} xl="10">
            <Row >
              <Col xs={11} lg={6} xxl={4} className={cx('margin-top')}>
                <div className={cx("selectWarp")} >
                  <Form.Label style={{ marginBottom: '0' }} className={cx("px-1", 'px-sm-2', "py-2", "lable-w")}>代碼/名稱</Form.Label>
                  <SelectSearch
                    className={cx("select-search-one", 'min-width-197px')}
                    options={targets}
                    search
                    filterOptions={fuzzySearch}
                    emptyMessage="找不到標的"
                    placeholder="請選擇標的"
                    value={sym}
                    onChange={(e) => handleOnchange(e)}
                  />
                </div>
              </Col>
              <Col xs={11} lg={6} xxl={4} className={cx('margin-top')}>
                <div className={cx("selectWarp")}>
                  <Form.Label style={{ marginBottom: '0' }} className={cx("px-1", 'px-sm-2', "py-2", "lable-w")}>認購/認售</Form.Label>
                  <ButtonGroup>
                    {cpOption.map((radio, idx) => (
                      <ToggleButton
                        className={cx("toggleBtn", cp === radio.value && "toggleBtn-active")}
                        key={idx}
                        id={`radio-${idx}`}
                        type="radio"
                        variant="outline-primary"
                        name="radio"
                        value={radio.value}
                        checked={cp === radio.value}
                        onChange={(e) => { setCp(e.target.value) }}
                      >
                        {radio.name}
                      </ToggleButton>
                    ))}
                  </ButtonGroup>
                </div>
              </Col>
              <Col xs={11} lg={6} xxl={4}>
              </Col>
            </Row>
          </Col>
        </Row>


        <Row className={cx("py-3", "align-items-center", "border-bottom")} >
          <div className={cx("col", "text-blue-light", "mb-sm-0", "fontSize-22")}
          >
            <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="currentColor" className="text-color" viewBox="0 0 16 16">
              <path d="M10.804 8L5 4.633v6.734L10.804 8zm.792-.696a.802.802 0 0 1 0 1.392l-6.363 3.692C4.713 12.69 4 12.345 4 11.692V4.308c0-.653.713-.998 1.233-.696l6.363 3.692z" />
            </svg>篩選條件
          </div>
          <Col className={cx("px-2", "border-left")} xl="10">
            <Row>
              <Col xs={11} lg={6} xxl={4} className={cx('margin-top')}>
                <div className={cx("selectWarp")}>
                  <Form.Label className={cx("px-1", 'px-sm-2', "py-2", "lable-w")}>價內外程度</Form.Label>
                  <SelectSearch
                    options={priceOption}
                    value={p1}
                    onChange={(selected) => setP1(selected)}
                  />
                  <span className={cx("selecterdash")}>-</span>
                  <SelectSearch
                    options={priceOption}
                    value={p2}
                    onChange={(selected) => setP2(selected)}
                  />
                </div>
              </Col>
              <Col xs={11} lg={6} xxl={4} className={cx('margin-top')}>
                <div className={cx("selectWarp")}>
                  <Form.Label className={cx("px-1", 'px-sm-2', "py-2", "lable-w")}>剩餘天數</Form.Label>
                  <SelectSearch
                    options={dayOption}
                    value={d1}
                    onChange={(selected) => setD1(selected)}
                  />
                  <span className={cx("selecterdash")}>-</span>
                  <SelectSearch
                    options={dayOption}
                    value={d2}
                    onChange={(selected) => setD2(selected)}
                  />
                </div>
              </Col>

              <Col xs={11} lg={6} xxl={4} className={cx('margin-top')}>
                <div className={cx("selectWarp")}>
                  <Form.Label className={cx("px-1", 'px-sm-2', "py-2", "lable-w")}>行使比例</Form.Label>
                  <SelectSearch
                    options={percentOption}
                    value={r1}
                    onChange={(selected) => setR1(selected)}
                  />
                  <span className={cx("selecterdash")}>-</span>
                  <SelectSearch
                    options={percentOption}
                    value={r2}
                    onChange={(selected) => setR2(selected)}
                  />
                </div>
              </Col>

              <Col xs={11} lg={6} xxl={4} className={cx('margin-top')}>
                <div className={cx("selectWarp")}>
                  <Form.Label className={cx("px-1", 'px-sm-2', "py-2", "lable-w")}>發行人</Form.Label>
                  <SelectSearch
                    className={cx("select-search-one")}
                    options={publisher}
                    filterOptions={fuzzySearch}
                    search
                    emptyMessage="找不到發行人"
                    placeholder="請選擇發行人"
                    value={pub}
                    onChange={(selected) => setPub(selected)}
                  />
                </div>
              </Col>

              <Col xs={11} lg={6} xxl={4} className={cx('margin-top')}>
                <div className={cx("inputWarp")}>
                  <Form.Group>
                    <Form.Label className={cx("px-1", 'px-sm-2', "py-2", "lable-w")}>履約價</Form.Label>
                    <input
                      className={cx("form-selece-w")}
                      type="number"
                      value={ep1}
                      step="0.01"
                      onChange={(e) => setEp1(e.target.value.toString())}
                    />
                    <span className={cx("selecterdash")}>-</span>
                    <input
                      className={cx("form-selece-w")}
                      type="number"
                      value={ep2}
                      step="0.01"
                      onChange={(e) => setEp2(e.target.value.toString())}
                    />
                  </Form.Group>
                </div>
              </Col>

              <Col xs={11} lg={6} xxl={4} className={cx('margin-top')}>
                <div className={cx("selectWarp")}>
                  <Form.Label className={cx("px-1", 'px-sm-2', "py-2", "lable-w")}>成交量</Form.Label>
                  <SelectSearch
                    options={qtyOption}
                    value={qty1}
                    onChange={(selected) => setQty1(selected)}
                  />
                  <span className={cx("selecterdash")}>-</span>
                  <SelectSearch
                    options={qtyOption}
                    value={qty2}
                    onChange={(selected) => setQty2(selected)}
                  />
                </div>
              </Col>

              <Col xs={11} lg={6} xxl={4} className={cx('margin-top')}>
                <div className={cx("selectWarp")}>
                  <Form.Label className={cx("px-1", 'px-sm-2', "py-2", "lable-w")}>買賣價差比</Form.Label>
                  <SelectSearch
                    options={dfOption}
                    value={df1}
                    onChange={(selected) => setDf1(selected)}
                  />
                  <span className={cx("selecterdash")}>-</span>
                  <SelectSearch
                    options={dfOption}
                    value={df2}
                    onChange={(selected) => setDf2(selected)}
                  />
                </div>
              </Col>
              <Col xs={11} lg={6} xxl={4} className={cx('margin-top')}>
                <div className={cx("selectWarp")}>
                  <Form.Label className={cx("px-1", 'px-sm-2', "py-2", "lable-w")}>買賣槓桿</Form.Label>
                  <SelectSearch
                    options={lvOption}
                    value={lv1}
                    onChange={(selected) => setLv1(selected)}
                  />
                  <span className={cx("selecterdash")}>-</span>
                  <SelectSearch
                    options={lvOption}
                    value={lv2}
                    onChange={(selected) => setLv2(selected)}
                  />
                </div>
              </Col>
              <Col xs={11} lg={6} xxl={4} className={cx('margin-top')}>
                <div className={cx("inputWarp")} />
              </Col>
            </Row>
          </Col>
        </Row>
        <div className={cx("row", "justify-content-center", "flex-nowrap p-3")}>
          <Button className={cx("col-4", "col-md-2", "search-btn")} onClick={() => { reSet() }}>重 設</Button>
          <Button className={cx("col-4", "col-md-2", "search-btn")} onClick={() => { search() }}>搜 尋</Button>
        </div >
      </div >
      <div className={cx("text-color", "container-left")}>
        <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" fill="currentColor" className={cx("text-color", "bi", "bi-play")} viewBox="0 0 16 16">
          <path d="M10.804 8 5 4.633v6.734L10.804 8zm.792-.696a.802.802 0 0 1 0 1.392l-6.363 3.692C4.713 12.69 4 12.345 4 11.692V4.308c0-.653.713-.998 1.233-.696l6.363 3.692z" />
        </svg>
        查詢結果  <Badge className={cx("badge-box")} >{warrantrDataCount}筆</Badge>

        {warrantsCsvWarrantLoading ? <Spinner animation="border" /> : warrantrDataCount > 0 ? <CSVLink data={warrantsCsv} filename="權證標的篩選匯出.csv" >
          <div className={cx("download-btn")}>
            Excel 匯出
          </div>
        </CSVLink> : null}
      </div>
      <div className={cx("updateTime")}>
        更新時間：{queryTime || ""}
      </div>

      {warrantrData && warrantrData?.length > 0 && <div className={cx('tableHead-minHeight')}><Table columns={columns} data={warrants || []} sortName={tableAsc} sortAsc={asc} onHeaderClick={(name, asc) => handleChangeSort(name)} /></div>}
      {
        warrantrPages > 0 && warrantrData && warrantrData?.length > 0 && <div className={cx("paginatioWrap")}>
          <Pagination>
            <Pagination.First onClick={() => (setPage(1))} disabled={page === 1} />
            <Pagination.Prev onClick={() => page > 1 && setPage(page - 1)} disabled={page - 1 === 0} />
            {warrantrPages >= 1 && <Pagination.Item onClick={() => setPage(1)} active={page === 1}>{1}</Pagination.Item>}
            {warrantrPages >= 2 && <Pagination.Item onClick={() => setPage(2)} active={page === 2}>{2}</Pagination.Item>}
            {warrantrPages >= 3 && page < 5 && <Pagination.Item onClick={() => setPage(3)} active={page === 3}>{3}</Pagination.Item>}
            {warrantrPages >= 5 && page > 4 && < Pagination.Ellipsis />}
            {page >= 4 && <Pagination.Item onClick={() => warrantrPages > page && setPage(page + 1)} active={page === page}>{page}</Pagination.Item>}
            {warrantrPages > page && warrantrPages - page >= 1 && page >= 3 && <Pagination.Ellipsis />}
            <Pagination.Next onClick={() => setPage(page + 1)} disabled={page === warrantrPages} />
            <Pagination.Last onClick={() => setPage(warrantrPages)} disabled={page === warrantrPages} />
          </Pagination>
        </div >
      }
      <ul className={cx("list-dot", "text-secondary", "small")}>
        <li>
          註: 剩餘天數以日曆日計算。
        </li>
        <li>
          註: 委買隱含波動率為權證買價所反推之隱含波動率，非發行商之造市波動率。
        </li>
      </ul >
      <OrderModel
        isOpen={show}
        mtype={mtype}
        sessionId={sessionId}
        handleClose={handleClose}
        symCnName={symCnName}
        handleSymCnName={(name) => { setSymCnName(name) }}
        sym={orderSym}
        handleSym={(orderSym) => { setOrderSym(orderSym) }}
        buyOrSell={orderBS}
        handleBuyOrSell={(bs) => setOrderBS(bs)}
        orderPriceType={orderOrt}
        handleOrderPriceType={(type) => { handlePriceType(type) }}
        orderTime={orderTif}
        handleOrderTime={(tif) => { setOrderTif(tif) }}
        price={orderP1 || 0}
        handleOrderPrice={(price) => { handlePrice(price) }}
        qty={orderQty || 0}
        handleOrderQty={(qty) => { setOrderQty(qty) }}
        handleOrderPlace={() => { handleOrderPlace() }}
        target_money={target_money}
        target_upprice={t_up_stop}
        target_downprice={t_down_stop}
      />
      <ShareModel
        isOpen={showinviteModel}
        handleClose={() => { handleShareModelClose() }}
        istop6K={istop6K}
        invitationCode={invitationCode}
        isPrize={isPrize}
      />
      <BeginnerModel
        isOpen={GuideDisplay}
        handleClose={() => {
          retry();
          api.userGuideClose({ cu_id: cuid })
        }}
      />
    </Container >
  );
};
function usePublisherInfo() {
  const { loading, value } = useAsync(api.getPublisherQuery, []);

  function formatter(data: Publisher): SelectTarget {
    return {
      name: data.name,
      value: data.name,
    };
  }
  const data = value?.publisher ? value?.publisher.map(formatter) : []
  const allOption = {
    name: "全部",
    value: "",
  };
  const NewData = data.concat(allOption).sort((a, b) => (a.value > b.value ? 1 : -1));
  const publisher = React.useMemo(() => {
    return NewData
  }, [loading]);


  return {
    loading,
    publisher,
  };
}

function useTargetsInfo() {
  const { loading, value } = useAsync(api.getTargetsQuery, []);

  function Formatter(data: target): SelectTarget {
    const symCnName = data.name + "(" + data.id + ")"
    return {
      name: symCnName,
      value: symCnName,
      key: data.id,
    };
  }
  const targets = React.useMemo(() => {
    return value?.targets ? value?.targets.map(Formatter) : []
  }, [loading]);


  return {
    loading,
    targets,
  };
}

export default Order;
